import script from "./EvseProflie.vue?vue&type=script&lang=ts&setup=true"
export * from "./EvseProflie.vue?vue&type=script&lang=ts&setup=true"

import "./EvseProflie.vue?vue&type=style&index=0&id=784f34a0&lang=scss"

const __exports__ = script;

export default __exports__